import { createDecorator } from 'vue-class-component';
import { debounce } from 'lodash';
/*
 * This method finds and replaces methods found in a component's internal watcher list
 * with its debounced counterpart.
 */
function replaceWatcherHooks(originalMethod, debouncedMethod) {
    var _a;
    (_a = this._watchers) === null || _a === void 0 ? void 0 : _a.filter(function (watcher) { return watcher.cb === originalMethod; }).forEach(function (watcher) {
        watcher.cb = debouncedMethod;
    });
}
// Disabling this rule here because the helper function to be below the main export is more
// navigatable for the uninitiated. Because `replaceWatcherHooks` is not the main functionality of
// this file.
export default (function (wait, options) {
    if (options === void 0) { options = {}; }
    return createDecorator(function (componentOptions, key) {
        // Get the ref to the original `created` hook to call it later. Because we do not want to
        // replace the hook completely.
        var originalCreatedHook = componentOptions.created;
        componentOptions.created = function () {
            // Call the original hook.
            if (originalCreatedHook) {
                originalCreatedHook.call(this);
            }
            var originalMethod = this[key];
            // Change the component method with its throttled counterpart.
            this[key] = debounce(originalMethod, wait, options);
            // Change any watchers with the new throttled method. Because watchers are _mostly_
            // defined on the component definition, rather than after the component is initialized.
            // So the throttling that is applied after the initialization is not taken into effect
            // for watchers, and we need to do it manually.
            replaceWatcherHooks.call(this, originalMethod, this[key]);
        };
    });
});
